import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { ADPResourceService as ResourceService } from 'digital-core';

@Component({
  selector: 'faq-category',
  templateUrl: './faq-category.component.html',
  styleUrls: ['./faq-category.component.css']
})
export class FaqCategoryComponent implements OnInit {

  @Input() label: string;
  @Input() categories: any;

  helpTypeControl = new UntypedFormControl();

  constructor() { }

  ngOnInit(): void {
    this.helpTypeControl.setValue(this.categories[0]);
  }
}
